/* repo/reserMfa*/
import { omit, isEmpty } from "ramda";
import {
  insert as insertApi,
  drop as dropApi,
  isString,
} from "./api";
import { withDecoded, flattenData } from "./";
import authenticator from "authenticator";

function mapToModel(data: object): ResetMfa {
  return withDecoded(ResetMfaCodec, data, (decoded) => ({
    ...decoded,
  }));
}

function mapToChageset(user: Data): Data {
  return user;
}
import {ResetMfaCodec, ResetMfa, Data } from "../store/resetMfa/types";

export async function save(user: Data): Promise<ResetMfa> {

  return insertApi({
    nestedResourcePath: ["UserMfa"],
    id: user.user_id,
    data: { data: mapToChageset(user) },
  }).then((response) =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}
